export default __webpack_public_path__ + "7140152178afacc0d9a48d0072a919b9.png";